/**
 * SPEC-009 §34/plan §24/SIM-REQ-009 — reverse traversal cycle detection is
 * path-local: a node re-visited within the same backward walk is a cycle
 * boundary. This does not need a graph-wide SCC pass (that already exists
 * in the forward metrics engine, `@/domain/metrics/propagation/cycles`);
 * reverse only needs to know "have I already walked through this node on
 * my way here".
 */
export function isReverseCycle(visitedPath: ReadonlySet<string>, nodeId: string): boolean {
  return visitedPath.has(nodeId);
}
